import React from 'react';
import { Package, ChevronLeft } from 'lucide-react';
import { clsx } from 'clsx';
import { Stalker, Rarity } from '@stalker/core';
import { RARITY_ENUM_TO_COLOR } from '#shared/config/colors.js';

interface InventoryPageProps {
  player: Stalker;
  goBack: () => void;
  getItemEmoji: (typeId: string) => string;
  getItemName: (typeId: string) => string;
}

export const InventoryPage: React.FC<InventoryPageProps> = ({
  player,
  goBack,
  getItemEmoji,
  getItemName,
}) => {
  return (
    <div className="animate-in fade-in duration-500">
      <button onClick={goBack} className="group flex items-center gap-2 text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground mb-8 transition-all">
        <ChevronLeft size={14} className="group-hover:-translate-x-1 transition-transform" /> Вернуться
      </button>

      <div className="flex justify-between items-end mb-10">
        <h2 className="text-4xl font-black uppercase tracking-tighter text-foreground flex items-center gap-4">
          <Package size={32} className="text-primary" /> Рюкзак
        </h2>
        <div className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest border-b border-border pb-1">
          Заполнено: {player.inventory.length} / 50
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {player.inventory.map((item, i) => (
          <div key={i} className="p-5 rounded-sm border border-border bg-card/60 flex gap-5 items-center group hover:bg-card hover:border-primary/30 transition-all terminal-card">
             <div className={clsx(
               "w-14 h-14 rounded-sm bg-background flex items-center justify-center border-2 text-3xl shadow-2xl group-hover:scale-105 transition-transform duration-500",
               RARITY_ENUM_TO_COLOR[item.rarity] || "border-border"
             )}>
              {getItemEmoji(item.typeId)}
            </div>
            <div className="flex-1 min-w-0">
              <div className={clsx(
                "text-[9px] font-black uppercase tracking-widest mb-1 truncate",
                RARITY_ENUM_TO_COLOR[item.rarity]
              )}>
                {Rarity[item.rarity]}
              </div>
              <div className="font-bold uppercase text-sm text-foreground truncate">{getItemName(item.typeId)}</div>
              <div className="text-[9px] text-muted-foreground uppercase font-bold tracking-tighter mt-1">{item.category}</div>
            </div>
          </div>
        ))}
        {player.inventory.length === 0 && (
          <div className="col-span-full p-24 text-center border-2 border-dashed border-border rounded-sm opacity-20">
             <Package size={48} className="mx-auto mb-4 opacity-20" />
             <p className="text-sm uppercase font-black tracking-[0.3em]">Инвентарь пуст</p>
          </div>
        )}
      </div>
    </div>
  );
};
